import { useAdminExamLocationRequestListSearchParams } from '../../hooks';
import { InReviewAdminExamLocationRequestList } from '../in-review-admin-exam-location-request-list';
import RejectedAdminExamLocationRequestList from '../rejected-admin-exam-location-request-list/rejected-admin-exam-location-request-list';

export default function AdminExamLocationRequestList() {
  const [{ status }] = useAdminExamLocationRequestListSearchParams();

  switch (status) {
    case 'IN_REVIEW':
      return <InReviewAdminExamLocationRequestList />;
    case 'REJECTED':
      return <RejectedAdminExamLocationRequestList />;
    default:
      return null;
  }
}
